import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aec9d11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative inline-block" }

import { ref, computed, onBeforeUnmount } from 'vue'

type Props = {
    message: string
    position?: 'top' | 'bottom'
    delay?: number
    disabled?: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    message: { type: String, required: true, default: 'Tooltip message' },
    position: { type: String, required: false, default: 'top' },
    delay: { type: Number, required: false, default: 250 },
    disabled: { type: Boolean, required: false, default: false }
  },
  setup(__props: any) {

const props = __props as { message: string, position: 'top' | 'bottom', delay: number, disabled: boolean }


const isVisible = ref<boolean>(false)

const referrer = ref<HTMLElement>()
const tooltip = ref<HTMLElement>()

const tooltipPosition = computed(() => {
    return {
        left: `${Number(referrer.value?.getBoundingClientRect().width) / 2 -
            Number(tooltip.value?.getBoundingClientRect().width) / 2}px`,
        ...(props.position === 'top' && {
            bottom: `${Number(referrer.value?.getBoundingClientRect().height) + 15}px`,
        }),
        ...(props.position === 'bottom' && {
            top: `${Number(referrer.value?.getBoundingClientRect().height) + 15}px`,
        }),
    }
})

const tooltipDelay = ref()
const handleShowTooltip = () => {
    if (!props.disabled) {
        tooltipDelay.value = setTimeout(() => {
            isVisible.value = true
        }, props.delay || 250)
    }
}

const handleHideTooltip = () => {
    clearTimeout(tooltipDelay.value)
    isVisible.value = false
}

onBeforeUnmount(() => clearTimeout(tooltipDelay.value))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['referrer'] = _value
        referrer.value = _value
      },
      class: "h-full flex",
      onMouseenter: handleShowTooltip,
      onMouseleave: handleHideTooltip
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 544),
    (isVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: (_value, _refs) => {
            _refs['tooltip'] = _value
            tooltip.value = _value
          },
          style: _normalizeStyle([_unref(tooltipPosition), {"min-width":"180px"}]),
          class: _normalizeClass(["tooltip absolute z-50 bg-gray2 shadow-md text-white text-sm px-8 py-2 rounded-md text-center", {
                'animate-fade-in-up tooltip--top': props.position === 'top',
                'animate-fade-in-down tooltip--bottom': props.position === 'bottom',
            }])
        }, _toDisplayString(props.message), 7))
      : _createCommentVNode("", true)
  ]))
}
}

})